import { CohortEnumSchema } from '@eigtech/auth0-types';
import { z } from 'zod';
import { MeetingsDataSourceSchema } from './dataSource.js';
import { MeetingsMetadataSchema } from './meetingMetadata.js';
export const ScreenshotSchema = z.object({
    author: z.string().optional(),
    cohort: CohortEnumSchema,
    dateAdded: z.string().datetime(),
    description: z.string().optional(),
    filename: z.string(),
    label: z.string().optional(),
    meetingId: z.string(),
    metadata: MeetingsMetadataSchema,
    notes: z.string(),
    objectKey: z.string(),
    publishedOn: z.string().datetime().optional(),
    source: MeetingsDataSourceSchema,
});
export const UnlabeledScreenshotLabelSchema = z.literal('UNLABELED');
export const OutdoorScreenshotLabelSchema = z.enum([
    'ADDRESS VERIFICATION',
    'ESTIMATOR INFO',
    'FRONT ELEVATION',
    'LEFT ELEVATION',
    'REAR ELEVATION',
    'RIGHT ELEVATION',
    'ROOF BACK',
    'ROOF FRONT',
    'ROOF LEFT',
    'ROOF RIGHT',
]);
export const IndoorScreenshotLabelSchema = z.enum([
    'KITCHEN',
    'MASTER BEDROOM',
    'MASTER BATHROOM',
    'BEDROOM',
    'BATHROOM',
    'LIVING ROOM',
    'ENTRY',
    'OFFICE',
    'GUEST BEDROOM',
    'DEN',
    'DINING ROOM',
]);
export const ScreenshotLabelSchema = z.enum([
    ...OutdoorScreenshotLabelSchema.options,
    ...IndoorScreenshotLabelSchema.options,
]);
export const baseOutdoorScreenshotLabels = [
    {
        label: 'Address Verification',
        value: ScreenshotLabelSchema.enum['ADDRESS VERIFICATION'],
    },
    {
        label: 'Estimator Info',
        value: ScreenshotLabelSchema.enum['ESTIMATOR INFO'],
    },
    {
        label: 'Front Elevation',
        value: ScreenshotLabelSchema.enum['FRONT ELEVATION'],
    },
    {
        label: 'Left Elevation',
        value: ScreenshotLabelSchema.enum['LEFT ELEVATION'],
    },
    {
        label: 'Rear Elevation',
        value: ScreenshotLabelSchema.enum['REAR ELEVATION'],
    },
    {
        label: 'Right Elevation',
        value: ScreenshotLabelSchema.enum['RIGHT ELEVATION'],
    },
    {
        label: 'Roof - Back',
        value: ScreenshotLabelSchema.enum['ROOF BACK'],
    },
    {
        label: 'Roof - Front',
        value: ScreenshotLabelSchema.enum['ROOF FRONT'],
    },
    {
        label: 'Roof - Left',
        value: ScreenshotLabelSchema.enum['ROOF LEFT'],
    },
    {
        label: 'Roof - Right',
        value: ScreenshotLabelSchema.enum['ROOF RIGHT'],
    },
];
export const baseIndoorScreenshotLabels = [
    {
        label: 'Kitchen',
        value: ScreenshotLabelSchema.enum['KITCHEN'],
    },
    {
        label: 'Master Bedroom',
        value: ScreenshotLabelSchema.enum['MASTER BEDROOM'],
    },
    {
        label: 'Bedroom',
        value: ScreenshotLabelSchema.enum['BEDROOM'],
    },
    {
        label: 'Living Room',
        value: ScreenshotLabelSchema.enum['LIVING ROOM'],
    },
    {
        label: 'Entry',
        value: ScreenshotLabelSchema.enum['ENTRY'],
    },
    {
        label: 'Office',
        value: ScreenshotLabelSchema.enum['OFFICE'],
    },
    {
        label: 'Guest Bedroom',
        value: ScreenshotLabelSchema.enum['GUEST BEDROOM'],
    },
    {
        label: 'Den',
        value: ScreenshotLabelSchema.enum['DEN'],
    },
    {
        label: 'Dining Room',
        value: ScreenshotLabelSchema.enum['DINING ROOM'],
    },
];
export const baseScreenshotLabels = [
    ...baseOutdoorScreenshotLabels,
    ...baseIndoorScreenshotLabels,
];
